// src/api/axios.js
import axios from 'axios'
import { API_BASE_URL } from '@/config';
import { ElMessage } from 'element-plus'
// 创建 axios 实例
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000, // 延长超时时间
  retry: 3, // 重试次数
  retryDelay: 1000, // 重试间隔
  validateStatus(status) {
		switch (status) {
			// case 400:
			// 	ElMessage.error('请求出错')
			// 	break
			case 401:
				ElMessage.warning({
					message: '授权失败，请重新登录'
				})
        //window.open('https://sso.orks.com.cn', '_parent');
				return
			// case 403:
			// 	ElMessage.warning({
				// 		message: '拒绝访问'
				// 	})
			// 	break
			// case 404:
			// 	ElMessage.warning({
			// 		message: '请求错误,未找到该资源'
			// 	})
			// 	break
			// case 500:
			// 	ElMessage.warning({
				// 		message: '服务端错误'
				// 	})
			// 	break
		}
		return status >= 200 && status < 300
	}
})

// 添加请求重试机制
axiosInstance.interceptors.response.use(undefined, (err) => {
  const config = err.config
  if(!config || !config.retry) return Promise.reject(err)
  
  config.__retryCount = config.__retryCount || 0
  if(config.__retryCount >= config.retry) {
    return Promise.reject(err)
  }
  
  config.__retryCount += 1
  return new Promise(resolve => {
    setTimeout(() => resolve(axiosInstance(config)), config.retryDelay)
  })
})


// 请求拦截器
axiosInstance.interceptors.request.use(
  function(config) {
    //console.log("config:", config.url);
      let key = window.localStorage.getItem("key");
      //console.log("Token in request interceptor:", key);
      let token = window.localStorage.getItem("token");
    
      if (key && config.url == "getFromServletRequest") {
          config.headers.Authorization = key;
      }
      if (token) {
          config.headers.token = token;
      }
      return config;
  },
  function(error) {
      return Promise.reject(error);
  }
)


// 响应拦截器
axiosInstance.interceptors.response.use(
  function(response) {
    // 对响应数据做点什么
    return response
  },
  function(error) {
    let errorMessage = '网络请求错误'
    if (error.response) {
      // 服务器返回错误状态码
      errorMessage = `服务器错误: ${error.response.status}`
    } else if (error.request) {
      // 请求已发出但没有响应
      errorMessage = '后端服务无响应，请检查:'
      + `\n1. 后端服务是否运行在 ${API_BASE_URL}`
      + '\n2. 网络连接是否正常'
      + '\n3. 是否存在跨域问题'
    }
    console.error('请求错误详情:', error)
    ElMessage.error(errorMessage)
    return Promise.reject(error)
  }
)



export default axiosInstance

